import { FC } from 'react';
import { Box, Stack, Theme } from '@mui/material';
import { getFirstLastName } from '../../lib/helpers';
import { createUseStyles } from 'react-jss';
import Menu from '../menu';
import UserBadge from './user-badge';
import Text from '../text';
import Button from '../button';
import useApp from '@/hooks/use-app.hook';
import useFeature from '@/hooks/use-feature.hook';
import useAppData from '@/hooks/use-app-data.hook';
import { AppDataQueryKey } from '@/lib/query-client';
import { AuthRoleLabels } from '@/lib/services/auth.service';
import useUserControl from '@/hooks/use-user-control.hook';
import useIntercom from '@/hooks/use-intercom.hook';
import { OrgBasicInfo } from '@/lib/models/org';

const useStyles = createUseStyles((theme: Theme) => ({
  footer: {
    borderTop: `1px solid ${theme.palette.divider}`,
  },
}));

const UserMenu: FC = () => {
  const styles = useStyles();
  const { user, signOut } = useApp();
  const { hasAssume } = useFeature();
  const { checkLockedAndEmit } = useUserControl();
  const { hardShutdown } = useIntercom();

  const { displayName, email } = user!;
  const username = displayName || '';
  const { first, last } = getFirstLastName(username);
  const hasName = Boolean(first) || Boolean(last);

  let NameEl = <Text size="large">{email}</Text>;

  if (hasName) {
    NameEl = (
      <Stack gap={0.5}>
        <Text size="large">{[first, last].join(' ')}</Text>
        <Text color="grey">{email}</Text>
      </Stack>
    );
  }

  const { data } = useAppData<OrgBasicInfo>(AppDataQueryKey.OrgBasicInfo);
  const { name } = data || {};
  const roleLabel = user?.role ? AuthRoleLabels[user.role] : '';

  const handleSignOut = () => {
    if (checkLockedAndEmit()) {
      return false;
    }
    hardShutdown();
    signOut();
  };

  return (
    <Box>
      <Menu trigger={<UserBadge user={user!} />}>
        {NameEl}

        <Stack gap={0.5} mt={2}>
          <Text>{name}</Text>
          <Text color="grey">{roleLabel}</Text>
        </Stack>

        {!hasAssume && (
          <Stack
            className={styles.footer}
            direction="row"
            justifyContent="flex-end"
            mt={2}
            pt={2}
          >
            <Button label="Sign Out" onClick={handleSignOut} />
          </Stack>
        )}
      </Menu>
    </Box>
  );
};

export default UserMenu;
